export function getPath(state) {
	var fullPath = "/my";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
	} else {
		fullPath += "/" + VIEWS.SHELF_VIEW;
	}

	if (state.detailsView) {
		fullPath += "/" + state.detailsView;
		if (state.textID) {
			fullPath += "/" + state.textID;
		}
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	state.activeView = params.active_view;
	state.detailsView = params.details_view;
	state.textID = params.text_id;
	
	return state;
}

export const VIEWS = {
	SHELF_VIEW: "shelf",
	LOGS_VIEW: "reading"
}


export var PATH = "/my/:active_view/:details_view?/:text_id?";


// WEBPACK FOOTER //
// ./modules/lib/routing/DataToggleRouting.js